import { render, staticRenderFns } from "./TenantList.vue?vue&type=template&id=40ab56ca&scoped=true&"
import script from "./TenantList.vue?vue&type=script&lang=js&"
export * from "./TenantList.vue?vue&type=script&lang=js&"
import style0 from "./TenantList.vue?vue&type=style&index=0&id=40ab56ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ab56ca",
  null
  
)

export default component.exports